<!-- 抽奖 -->
<template>
  <div :class="$style.lottery">
    <ul :class="$style.peaches">
      <li
        v-for="i in 5"
        :key="i"
        :class="{
          [$style.shaking]: isShaking,
          [$style.falling]: i === 1 && peach1Fall
        }"
      />
    </ul>
    <div :class="$style['btn-container']">
      <!-- 抽奖按钮 -->
      <button :class="$style['btn-lottery']" @click="onLottery" />
      <!-- 查看活动奖励 -->
      <button :class="$style['btn-view-prize']" @click="$refs.prize.show()" />
    </div>
    <!-- 查看活动规则 -->
    <button :class="$style['btn-view-rule']" @click="$refs.rule.show()" />
    <!-- 活动奖励弹窗 -->
    <popup-frame
      ref="prize"
      size="lg"
      :customStyle="{ transform: 'translate3d(-50%, -50%, 0) scale(1.2)' }"
    >
      <div
        style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.3rem; width: 100%; height: 100%;"
      >
        <img :src="prizeImg" style="width: 5.74rem; height: 7.39rem;" />
        <!-- 马上参与 -->
        <button :class="$style['btn-join']" @click="$refs.prize.hide()" />
      </div>
    </popup-frame>
    <!-- 活动规则弹窗 -->
    <popup-frame ref="rule" size="lg">
      <div :class="$style.rule">
        <div
          v-html="activityRuleHtml"
          style="height: 90%; overflow-y: auto; -webkit-overflow-scrolling: touch;"
        />
      </div>
    </popup-frame>
    <!-- 中奖信息弹窗 -->
    <popup-frame ref="winPrize" size="sm">
      <div :class="$style['win-prize']">
        <p>
          恭喜获得{{
            prizeName
          }}奖励，奖励已发放至游戏内游戏中，请道友登录游戏查收哦~
        </p>
        <img :src="prizeIcon" style="width: 1.93rem; height: 2.29rem;" />
        <div
          style="display: flex; align-items: center; justify-content: center; gap: 1rem;"
        >
          <!-- 查看已获奖励 -->
          <button
            :class="$style['btn-view-own-prize']"
            @click="onViewOwnPrize"
          />
          <!-- 确认 -->
          <button
            :class="$style['btn-confirm']"
            @click="$refs.winPrize.hide()"
          />
        </div>
      </div>
    </popup-frame>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { PopupFrame } from "@/components/widgets";
import { lottery } from "@/api";

export default {
  name: "TheLottery",
  components: { PopupFrame },
  data() {
    return {
      isShaking: false,
      peach1Fall: false,
      prizeName: "",
      prizeIcon: "",
      prizeType: 1
    };
  },
  props: {
    rulesConfig: { type: Object, default: () => ({}) }
  },
  computed: {
    ...mapGetters(["user", "lotteryCount"]),
    /* 是否已登录 */
    userName() {
      return this.user && this.user.role_name;
    },
    /* 奖励图 */
    prizeImg() {
      // 无图片时显示占位图
      return (
        this.rulesConfig.reward_img ||
        "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      );
    },
    /* 活动规则 */
    activityRuleHtml() {
      return this.rulesConfig.activity_rule || "";
    }
  },
  methods: {
    ...mapActions(["setLotteryCount"]),
    /** 查看已获奖励 */
    onViewOwnPrize() {
      this.$refs.winPrize.hide();
      this.$emit("show-prize-records");
    },
    /** 开始桃子晃动动画，持续2秒，结束后第一颗桃子掉落并弹出中奖信息 */
    startShaking() {
      // 滚动到页面顶部
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.isShaking = true;
      this.peach1Fall = false;
      setTimeout(() => {
        this.isShaking = false;
        this.peach1Fall = true;
        // 桃子掉落动画结束后弹出弹窗
        setTimeout(() => {
          if (this.prizeType === 2) {
            // 实物奖：弹出收货地址
            this.$emit("bind-address");
          } else {
            // 虚拟奖：弹出中奖信息
            this.$refs.winPrize.show();
          }
        }, 500);
      }, 1500);
    },
    /** 点击抽奖按钮 */
    async onLottery() {
      // 未登录时弹出登录弹窗
      if (!this.userName) {
        this.$emit("login");
        return;
      }
      if (this.lotteryCount > 0) {
        // 请求抽奖接口
        const { code, data } = await lottery();
        if (code === 0) {
          this.prizeName = data.award_name || "";
          this.prizeIcon = data.award_icon || "";
          this.prizeType = data.type || 1;
          // 更新抽奖次数
          this.setLotteryCount(data.residue);
          this.startShaking();
        }
      } else {
        // 定位到任务模块
        this.$emit("go-tasks");
      }
    }
  },
  mounted() {
    // 首次进入限定大奖选项卡时弹出活动奖励，每个浏览器仅弹一次
    if (!localStorage.getItem("lottery_prize_shown")) {
      this.$refs.prize.show();
      localStorage.setItem("lottery_prize_shown", "1");
    }
  }
};
</script>

<style lang="less" module>
.lottery {
  .background-fill("./images/lottery-bg.jpg");

  position: relative;
  height: 21rem;
}

.btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 2rem;
}

.btn-lottery {
  .size(4.68rem, 1.89rem);
  .background-fill("./images/btn-lottery.png");
}

.btn-view-prize {
  .size(4.68rem, 1.89rem);
  .background-fill("./images/btn-view-prize.png");
}

.btn-view-rule {
  .size(2.59rem, 1.01rem);
  .background-fill("./images/btn-view-rule.png");

  position: absolute;
  right: 0.2rem;
  bottom: 3.92rem;
}

.btn-join {
  .size(1.94rem, 0.68rem);
  .background-fill("./images/btn-join.png");
}

.rule {
  width: 5.5rem;
  margin: 0 auto;
  padding-top: 0.5rem;
  font-size: 0.32rem;
  height: 100%;

  // 标题
  &::before {
    .size(4.03rem, 0.41rem);
    .background-fill("./images/rule-title.png");

    content: "";
    display: block;
    margin: 0 auto 0.3rem;
  }
}

.win-prize {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  width: 6.5rem;
  margin: 0 auto;
  font-size: 0.27rem;

  // 标题
  &::before {
    .size(5.61rem, 0.46rem);
    .background-fill("./images/win-prize-title.png");

    content: "";
  }
}

.btn-confirm {
  .size(1.48rem, 0.69rem);
  .background-fill("./images/btn-confirm.png");
}

.btn-view-own-prize {
  .size(2.7rem, 0.69rem);
  .background-fill("./images/btn-view-own-prize.png");
}

.peaches {
  position: absolute;
  top: 1rem;
  left: 0;
  right: 0;

  li {
    .size(1.82rem, 1.85rem);
    .background-fill("./images/peach.png");

    position: absolute;
    transform-origin: 60% 80%;

    &:nth-child(1) {
      top: 2.65rem;
      left: 1.6rem;
      transform: rotate(-35deg);
    }

    &:nth-child(2) {
      top: 0.5rem;
      left: 8.1rem;
      transform: rotate(-50deg) scale(1.05);
    }

    &:nth-child(3) {
      top: 1.45rem;
      left: 3.9rem;
      transform: rotate(50deg);
    }

    &:nth-child(4) {
      top: 2.8rem;
      left: 3.7rem;
      transform: scaleX(-1) rotate(125deg);
    }

    &:nth-child(5) {
      top: 0.1rem;
      left: 3.2rem;
    }

    // 晃动动画 —— 模拟桃子快要掉落的自然摆动
    &.shaking {
      animation: peachShake 2s ease-out forwards;
    }

    &:nth-child(2).shaking {
      animation: peachShake2 2s ease-out forwards;
    }

    &:nth-child(3).shaking {
      animation: peachShake3 2s ease-out forwards;
    }

    &:nth-child(4).shaking {
      animation: peachShake4 2s ease-out forwards;
    }

    &:nth-child(5).shaking {
      animation: peachShake5 2s ease-out forwards;
    }

    // 第一颗桃子掉落动画
    &:nth-child(1).falling {
      animation: peachFall1 0.4s ease-in forwards;
    }
  }
}

@keyframes peachShake {
  0% {
    transform: rotate(-35deg);
  }
  5% {
    transform: rotate(-55deg);
  }
  10% {
    transform: rotate(-20deg);
  }
  16% {
    transform: rotate(-50deg);
  }
  22% {
    transform: rotate(-22deg);
  }
  30% {
    transform: rotate(-47deg);
  }
  38% {
    transform: rotate(-25deg);
  }
  48% {
    transform: rotate(-43deg);
  }
  58% {
    transform: rotate(-28deg);
  }
  70% {
    transform: rotate(-39deg);
  }
  82% {
    transform: rotate(-32deg);
  }
  100% {
    transform: rotate(-35deg);
  }
}

@keyframes peachShake2 {
  0% {
    transform: rotate(-50deg) scale(1.05);
  }
  5% {
    transform: rotate(-30deg) scale(1.05);
  }
  10% {
    transform: rotate(-65deg) scale(1.05);
  }
  16% {
    transform: rotate(-33deg) scale(1.05);
  }
  22% {
    transform: rotate(-62deg) scale(1.05);
  }
  30% {
    transform: rotate(-37deg) scale(1.05);
  }
  38% {
    transform: rotate(-58deg) scale(1.05);
  }
  48% {
    transform: rotate(-40deg) scale(1.05);
  }
  58% {
    transform: rotate(-55deg) scale(1.05);
  }
  70% {
    transform: rotate(-44deg) scale(1.05);
  }
  82% {
    transform: rotate(-50deg) scale(1.05);
  }
  100% {
    transform: rotate(-50deg) scale(1.05);
  }
}

@keyframes peachShake3 {
  0% {
    transform: rotate(50deg);
  }
  5% {
    transform: rotate(70deg);
  }
  10% {
    transform: rotate(35deg);
  }
  16% {
    transform: rotate(65deg);
  }
  22% {
    transform: rotate(37deg);
  }
  30% {
    transform: rotate(62deg);
  }
  38% {
    transform: rotate(40deg);
  }
  48% {
    transform: rotate(58deg);
  }
  58% {
    transform: rotate(43deg);
  }
  70% {
    transform: rotate(54deg);
  }
  82% {
    transform: rotate(48deg);
  }
  100% {
    transform: rotate(50deg);
  }
}

@keyframes peachShake4 {
  0% {
    transform: scaleX(-1) rotate(125deg);
  }
  5% {
    transform: scaleX(-1) rotate(105deg);
  }
  10% {
    transform: scaleX(-1) rotate(140deg);
  }
  16% {
    transform: scaleX(-1) rotate(108deg);
  }
  22% {
    transform: scaleX(-1) rotate(137deg);
  }
  30% {
    transform: scaleX(-1) rotate(112deg);
  }
  38% {
    transform: scaleX(-1) rotate(133deg);
  }
  48% {
    transform: scaleX(-1) rotate(115deg);
  }
  58% {
    transform: scaleX(-1) rotate(130deg);
  }
  70% {
    transform: scaleX(-1) rotate(119deg);
  }
  82% {
    transform: scaleX(-1) rotate(123deg);
  }
  100% {
    transform: scaleX(-1) rotate(125deg);
  }
}

@keyframes peachShake5 {
  0% {
    transform: rotate(0deg);
  }
  5% {
    transform: rotate(-18deg);
  }
  10% {
    transform: rotate(15deg);
  }
  16% {
    transform: rotate(-15deg);
  }
  22% {
    transform: rotate(12deg);
  }
  30% {
    transform: rotate(-12deg);
  }
  38% {
    transform: rotate(9deg);
  }
  48% {
    transform: rotate(-8deg);
  }
  58% {
    transform: rotate(6deg);
  }
  70% {
    transform: rotate(-4deg);
  }
  82% {
    transform: rotate(2deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

// 第一颗桃子掉落 —— ease-in 实现自由落体加速，角度单调递减自然过渡
@keyframes peachFall1 {
  0% {
    top: 2.65rem;
    left: 1.6rem;
    transform: rotate(-35deg);
  }
  100% {
    top: 7.84rem;
    left: 1.2rem;
    transform: rotate(-6deg);
  }
}
</style>
